import { useMemo } from 'react';
import { v4 as uuidv4 } from 'uuid';

import { AbsenceEntry, AbsenceType } from '~/data/absences/types';
import { AbsenceDataRow } from '~/scenes/PeopleModule/components/Tabs/AbsencesTab/components/AbsencesTable/data';
import { useCommonAbsenceTableColumnConfigs } from '~/scenes/PeopleModule/components/Tabs/AbsencesTab/components/AbsencesTable/data/useCommonAbsenceTableColumnConfigs';

type PropsType = {
  absenceType: AbsenceType;
  absenceEntries: AbsenceEntry[];
};

export const useAbsenceTableData = (props: PropsType) => {
  const { absenceType, absenceEntries } = props;

  const { columnConfigs } = useCommonAbsenceTableColumnConfigs<AbsenceDataRow>(
    {},
  );

  const { rows } = useMemo(() => {
    const relevantEntries = absenceEntries.filter(
      (a) => a.type === absenceType,
    );

    const rows = relevantEntries.map((entry: AbsenceEntry): AbsenceDataRow => {
      const { uid, reason, startDate, endDate, info, attachment, status } =
        entry;

      const commonEntryData = {
        id: uid ?? uuidv4(),
        reason: reason?.name ?? '',
        year: '',
        startDate,
        endDate,
        days: 0,
        hours: '',
        plannedWorkingHours: '',
        info: info ?? '',
        attachment: attachment?.name ?? '',
        status,
        approval: '',
        actions: '',
        meta: entry,
      };

      const resolveTypeEntryData = (
        entry: AbsenceEntry,
      ): Pick<
        AbsenceDataRow,
        'days' | 'hours' | 'plannedWorkingHours' | 'year'
      > => {
        if (entry.type === AbsenceType.SHORT) {
          const { days, hours, year, plannedWorkingHours } = entry;
          return {
            days: days ?? 0,
            hours: hours ?? 0,
            plannedWorkingHours: plannedWorkingHours ?? 0,
            year: year ?? 0,
          };
        }

        return {
          days: 0,
          hours: 0,
          plannedWorkingHours: 0,
          year: 0,
        };
      };

      return {
        ...commonEntryData,
        ...resolveTypeEntryData(entry),
      };
    });

    return {
      rows,
    };
  }, [absenceEntries, absenceType]);

  return {
    rows,
    columnConfigs,
  };
};
